import PropTypes from 'prop-types';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { useNonNullishFormFieldContext } from './form.context.js';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var propTypes = {
  /**
  * @deprecated
  * use size prop instead
  */
  sizeVariant: deprecatedProp(PropTypes.oneOf(['standard', 'mega']), DEPRECATED_PROP_MESSAGES.size),

  /**
  * The size of the label. Mega adds additional bottom margin and center aligns the text
  */
  size: PropTypes.oneOf(['standard', 'mega']),

  /**
  * The skin for the label. Line is intended to be used with the line skin on a form input component
  */
  skin: PropTypes.oneOf(['standard', 'line'])
};
var FormLabel = createComponent({
  displayName: 'FormLabel',
  root: 'label',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var _props$sizeVariant = props.sizeVariant,
          sizeVariant = _props$sizeVariant === void 0 ? 'standard' : _props$sizeVariant,
          _props$size = props.size,
          size = _props$size === void 0 ? sizeVariant : _props$size;
      var classes = new Set(['swan-label']);
      if (size === 'mega') classes.add('swan-label-mega');
      if (props.skin === 'line') classes.add('swan-label-skin-line');
      return classes;
    },
    processProps: function processProps(props) {
      var _useNonNullishFormFie = useNonNullishFormFieldContext(),
          inputId = _useNonNullishFormFie.inputId;

      return _object_spread_props(_object_spread({}, props), {
        htmlFor: inputId
      });
    }
  }
});
FormLabel.defaultProps = {
  size: 'standard',
  skin: 'standard'
};
export { FormLabel };